import { Component, Host, Prop, h } from '@stencil/core';

/**
 * A horizontal divider line to group content within dropdowns, lists, or other containers.
 */
@Component({
  tag: 'omk-divider',
  styleUrl: 'omk-divider.css',
  shadow: true,
})
export class OmkDivider {
  /** Add some space on both sides */
  @Prop({ reflect: true }) inset: boolean = false;
  /** Add some space at the start. The start could be left or right depending on text direction. */
  @Prop({ reflect: true }) insetStart: boolean = false;
  /** Add some space at the end. The end could be left or right depending on text direction. */
  @Prop({ reflect: true }) insetEnd: boolean = false;
  /** Dividers are decorative by default and not announced by assistive technology. Set this property to true for non-decorative dividers that should be announced. */
  @Prop() separator: boolean = false;
  /** Round off the edges when the thickness is customized. */
  @Prop({ reflect: true }) rounded: boolean = false;

  render() {
    return <Host role={this.separator ? 'separator' : ''} />;
  }
}
